import { render, staticRenderFns } from "./SettlementHistory.vue?vue&type=template&id=8b8874ae"
import script from "./SettlementHistory.vue?vue&type=script&lang=js"
export * from "./SettlementHistory.vue?vue&type=script&lang=js"
import style0 from "./SettlementHistory.vue?vue&type=style&index=0&id=8b8874ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports